import { Link } from "react-router-dom";
import "./ArticleCard.css";

function timeAgo(timestamp) {
  if (!timestamp) return "";
  const date =
    timestamp?.toDate ? timestamp.toDate() : new Date(timestamp);
  const diff = Math.floor((Date.now() - date.getTime()) / 1000);
  if (diff < 60) return `${diff}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

export default function ArticleCard({ post, size = "medium" }) {
  if (!post) return null;
  return (
    <article className={`article-card article-card--${size}`}>
      <Link to={`/post/${post.id}`} className="article-card-img-link">
        <div className="article-card-img-wrap">
          <img
            src={post.imageUrl}
            alt={post.title}
            className="article-card-img"
            loading="lazy"
          />
          <span className="article-card-category">{post.category}</span>
        </div>
      </Link>
      <div className="article-card-body">
        <Link to={`/post/${post.id}`} className="article-card-title-link">
          <h3 className="article-card-title">{post.title}</h3>
        </Link>
        {size !== "small" && (
          <p className="article-card-excerpt">{post.excerpt}</p>
        )}
        <div className="article-card-meta">
          <span className="article-card-author">{post.author}</span>
          <span className="article-card-dot">·</span>
          <span className="article-card-time">{timeAgo(post.timestamp)}</span>
          {post.views && (
            <>
              <span className="article-card-dot">·</span>
              <span className="article-card-views">
                {post.views.toLocaleString()} views
              </span>
            </>
          )}
        </div>
      </div>
    </article>
  );
}
